/**
 * Test ID utilities for Avatar component
 *
 * Pattern: All test IDs are generated via named setter functions.
 * This ensures consistency between components and tests.
 */

import { generateTestId } from "@client-shared";

/**
 * Generate test ID for Avatar container
 * @param identifier - Avatar identifier (e.g., 'user', 'profile')
 * @returns Test ID string
 */
export const setAvatarTestId = (identifier: string): string =>
  generateTestId("Avatar", identifier.replace(/\s+/g, "-").toLowerCase());

/**
 * Generate test ID for AvatarImage
 * @param identifier - Avatar identifier
 * @returns Test ID string
 */
export const setAvatarImageTestId = (identifier: string): string =>
  generateTestId("AvatarImage", identifier.replace(/\s+/g, "-").toLowerCase());

/**
 * Generate test ID for AvatarFallback
 * @param identifier - Avatar identifier
 * @returns Test ID string
 */
export const setAvatarFallbackTestId = (identifier: string): string =>
  generateTestId(
    "AvatarFallback",
    identifier.replace(/\s+/g, "-").toLowerCase(),
  );
